<template>
  <div class="order-signing-audit">
    <div class="order-filter-audit">
      <div class="tuolele-main-box sort-management-detail">
        <div class="tuolele-main-search">
          <el-form :inline="true" :model="search">
            <el-form-item>
              <el-input v-model="search.order_id" placeholder="签约单号" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="search.out_trade_no" placeholder="财务单号" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="search.ttpd_account_id" placeholder="学员ID" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="search.sub_name" placeholder="学员姓名" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="search.time_type" placeholder="筛选类型" style="width: 140px;">
                <el-option v-for="(key,val) in selectData.timeTypes" :key="'time_type'+key" :label="key" :value="val" />
              </el-select>
              <el-date-picker v-model="search.time" style="margin-left: 5px;" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="search.team_id" placeholder="师资组">
                <el-option v-for="(item,index) in selectData.team_list" :key="'team_id'+index" :label="item.team_name" :value="item.team_id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="search.order_type" placeholder="课时类型">
                <el-option v-for="(item,index) in selectData.order_type" :key="'order_type'+index" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="search.kpi_status" placeholder="订单类型">
                <el-option v-for="(val,key) in selectData.order_kpi_status" :key="'time_type'+key" :label="val.name" :value="val.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="search.order_status" placeholder="订单状态">
                <el-option v-for="(val,key) in selectData.order_status" :key="'order_status'+key" :label="val.name" :value="val.id" />
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="fnGetLists()">查询</el-button>
          </el-form>
        </div>
        <div class="table">
          <el-table
            :key="'tableKey'+tableKey"
            :data="tableData"
            border
            stripe
          >

            <el-table-column prop="create_time" label="创建时间" />
            <el-table-column prop="modify_time" label="最后操作时间" />
            <el-table-column prop="order_id" label="签约单号" />
            <el-table-column prop="sub_id" label="学员ID" />
            <el-table-column prop="sub_name" label="学员姓名" />
            <el-table-column prop="item_title" label="套餐名称" />
            <el-table-column prop="order_type" label="课时类型" />
            <el-table-column label="套餐价格（元）/数量">
              <template slot-scope="scope">
                {{ scope.row.total_price + '/' + scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column prop="actual_amount" label="实付金额（元）" />
            <el-table-column prop="payment_name" label="付款方式" />
            <el-table-column prop="kpi_status_name" label="订单类型" />
            <el-table-column prop="editor_name" label="提交人" />
            <el-table-column prop="headmaster_name" label="班主任" />
            <el-table-column prop="status_name" label="订单审核状态" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="detail(scope.row.order_id)">查看详情</el-button>
                <el-button v-if="scope.row.extra && scope.row.extra.order_img" size="mini" type="success" @click="contract(scope.row.extra)">电子合同</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer pagination-footer">
            <div class="block">
              <el-pagination
                layout="prev, pager, next, slot, jumper"
                :current-page.sync="search.p"
                prev-text="上一页"
                next-text="下一页"
                :total="search.total"
                :page-size="search.limit"
                @current-change="fnGetLists()"
              >
                <div class="chax">
                  {{ search.p }}/{{
                    search.total > 0 ? Math.ceil(search.total / search.limit) : 1
                  }}
                </div>
              </el-pagination>
              <div class="insert">
                <el-button type="primary">确定</el-button>
                <span class="pagination-count">
                  符合查询结果:
                  <i>{{ search.total }}条</i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible1"
      width="60%"
      :before-close="()=>dialogVisible1 = false"
      class="order-detail-dialog"
    >
      <TTPDOrderSigningAudit
        :order-detail="orderDetail"
      />
    </el-dialog>
  </div>
</template>
<script>

import TTPDOrderSigningAudit from './TTPDOrderSigningInfo.vue'
var moment = require('moment')

export default {
  name: 'TTPDOrderSignAuditDetailAll',
  components: {
    TTPDOrderSigningAudit
  },
  data() {
    return {
      type: 'signingAudit',
      dialogVisible1: false,
      tableKey: 0,
      search: {
        p: 1,
        limit: 10,
        order_id: '',
        out_trade_no: '',
        ttpd_account_id: '',
        sub_name: '',
        time_type: '',
        time: '',
        team_id: '',
        order_type: '',
        kpi_status: '',
        order_status: '',
        begin_time: '',
        end_time: ''
      },
      selectData: {
        order_kpi_status: {},
        order_type: [],
        order_status: {},
        team_list: [],
        payments: [
          { id: 'wx', name: '微信' },
          { id: 'turn', name: '转账' },
          { id: 'balance', name: '余额支付' },
          { id: 'dianping', name: '大众点评' }
        ],
        timeTypes: {
          '1': '创建时间',
          '2': '支付成功时间',
          '3': '最后操作时间'
        }
      },
      tableData: [],
      orderDetail: {}
    }
  },
  watch: {
    'search.time': {
      handler: function(newVal) {
        if (newVal && newVal.length > 1) {
          this.search.begin_time = moment(newVal[0]).format('YYYY-MM-DD')
          this.search.end_time = moment(newVal[1]).format('YYYY-MM-DD')
        } else {
          this.search.begin_time = ''
          this.search.end_time = ''
        }
      }
    }
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      if (this.search.begin_time && !this.search.time_type) {
        this.$message.error('请选择筛选类型')
        return
      }
      this.$http.ttpdGetOrderList(this.search).then((res) => {
        this.selectData.team_list = res.data.type_info.team_list || []
        this.selectData.order_type = res.data.type_info.order_type || []
        this.selectData.order_kpi_status = res.data.type_info.order_kpi_status || {}
        this.selectData.order_status = res.data.type_info.order_status || {}
        this.tableData = res.data.list
        this.tableKey++
      })
    },
    updateFilter(val) {
      this.search = val
    },
    contract(extra) {
      window.open(extra.order_img)
    },
    detail(order_id) {
      this.$http.ttpdGetOrderInfo({ order_id }).then((res) => {
        this.orderDetail = res.data
        this.$nextTick(() => {
          this.dialogVisible1 = true
        })
      })
    },
    updateInvoice() {

    }
  }
}
</script>
<style lang="scss"></style>
